// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.history.mentalstatus.UpdateMentalStatusRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateMentalStatusRequest extends GandalfModelBase {

	@GandalfLabel('Date of Onset')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dateOfOnset!: Date | null;

	@GandalfLabel('Disability Status Comments')
	@GandalfValidator({ sizeString: { message: 'Disability Status Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	disabilityStatusComments!: string | null;

	@GandalfLabel('Disability Status Snomed Code')
	@GandalfProperty({ designType: Number })
	disabilityStatusSnomedCodeId!: number | null;

	@GandalfLabel('Functional Status Comments')
	@GandalfValidator({ sizeString: { message: 'Functional Status Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	functionalStatusComments!: string | null;

	@GandalfLabel('Functional Status Snomed Code')
	@GandalfProperty({ designType: Number })
	functionalStatusSnomedCodeId!: number | null;

	@GandalfLabel('Mental Status Comments')
	@GandalfValidator({ sizeString: { message: 'Mental Status Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	mentalStatusComments!: string | null;

	@GandalfValidator({ notNull: { message: 'Mental Status Id must not be null.' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	mentalStatusId!: number;

	@GandalfLabel('Mental Status Snomed Code')
	@GandalfProperty({ designType: Number })
	mentalStatusSnomedCodeId!: number | null;

	@GandalfConstantDecorator(constants.Mood)
	@GandalfValidator({ notNull: { message: 'Mood must not be null.' } })
	@GandalfProperty({ designType: constants.Mood, isRequired: true })
	mood!: constants.Mood;

	@GandalfLabel('Assessment of Mood Affect')
	@GandalfValidator({ sizeString: { message: 'Assessment of Mood Affect cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	moodComments!: string | null;

	@GandalfConstantDecorator(constants.Orientation)
	@GandalfValidator({ notNull: { message: 'Orientation must not be null.' } })
	@GandalfProperty({ designType: constants.Orientation, isRequired: true })
	orientation!: constants.Orientation;

	@GandalfLabel('Orientation to Time/Person/Place')
	@GandalfValidator({ sizeString: { message: 'Orientation to Time/Person/Place cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	orientationComments!: string | null;

	@GandalfValidator({ notNull: { message: 'Version must not be null.' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	version!: number;

}
